import useReplacedText from '@v4/hooks/useReplacedText'
import useLineBreakHtml from '@v4/hooks/useLineBreakHtml'
import useEditor, { EDITOR_VARIANT } from '@v4/hooks/useEditor'
import AppStore from '@v4/store/appStore'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import useStyles from './EditableButton.styled'

export const useEditableButton = ({
	editable,
	onClick,
	onChange,
	displayEmpty,
	onLabelFocus,
	rounded,
	children = null,
	color = 'primary',
	autoFocus,
	...rest
}) => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const contentEditable = editable && isBuilderMode

	const { classes, cx } = useStyles({ rounded, color, ...rest }, { props: rest })
	const html = useReplacedText(children)
	const { active, elementRef } = useEditor({
		active: contentEditable,
		value: typeof children === 'string' ? children : '',
		parsedValue: typeof html === 'string' ? html : '',
		onChange,
		variant: EDITOR_VARIANT.SIMPLE,
		allowEmpty: displayEmpty,
		onFocus: onLabelFocus,
		clickOnFocus: isBuilderMode && !isQuestionBuilderMode,
		autoFocus,
	})
	const lineBreakHtml = useLineBreakHtml(html)

	return [
		{
			classes,
			cx,
			html: lineBreakHtml,
			contentEditable,
			activeEditor: active,
			elementRef,
			displayEmpty,
			...rest,
		},
		{
			handleClick: onClick,
		},
	]
}
